export const formatDateTime = (value) => {
  if (!value) return '-';
  if (typeof value.toDate === 'function') {
    return value.toDate().toLocaleString();
  }
  return new Date(value).toLocaleString();
};

export const getTimestampMillis = (value) => {
  if (!value) return null;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
};

export const isStuckProcessing = (job, staleMs) => {
  if (!job || job.status !== 'processing') return false;
  const updatedAtMs = getTimestampMillis(job.progressUpdatedAt || job.updatedAt);
  if (!updatedAtMs) return false;
  return Date.now() - updatedAtMs >= staleMs;
};

export const truncateFileName = (name, maxLength = 28) => {
  if (!name) return '-';
  if (name.length <= maxLength) return name;
  const extIndex = name.lastIndexOf('.');
  const hasExt = extIndex > 0 && extIndex < name.length - 1;
  const ext = hasExt ? name.slice(extIndex) : '';
  const base = hasExt ? name.slice(0, extIndex) : name;
  const sliceLength = Math.max(8, maxLength - ext.length - 1);
  return `${base.slice(0, sliceLength)}...${ext}`;
};

export const statusBadgeClass = (status) => {
  if (status === 'completed') return 'bg-emerald-100 text-emerald-700 border border-emerald-200';
  if (status === 'failed') return 'bg-red-100 text-red-700 border border-red-200';
  if (status === 'processing') return 'bg-blue-100 text-blue-700 border border-blue-200';
  return 'bg-amber-100 text-amber-700 border border-amber-200';
};
